'use client';

import React from 'react';

import { TeamBlock } from '../../_components/TeamBlock';
import { TeamBlockProps } from './types';

import classes from './index.module.scss';

export const TeamBlockGraphQL: React.FC<TeamBlockProps> = props => {
  const {
    id,
  } = props;

  return (
    <div id={`block-${id}`} className={classes.blockWrapper}>
      <TeamBlock teamBlock={props} />
    </div>
  );
};

export default TeamBlockGraphQL;
